import React from 'react';
import Navbar from '../../components/general/Navbar';
import Shop from '../../components/general/Shop';
import Footer from '../../components/general/Footer';

const ShopPage = () => {
  return (
    <>
      <Navbar />
      <Shop />
      <Footer />
    </>
  )
}

export default ShopPage;